// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60c4caa5","239":"fe81d5e1","667":"05705ece"}[chunkId] + ".chunk.js";
};